import env from '../config/env';
import service from '../api/channel.service';
import permission from '../api/permissions.service';

//constants
const data = {
    securityPermission: null,
    channels: [],
    channelAdd: null,
    responseChannel: null,
    noPermittedChannel: ''
}
//types
const SECURITY_PERMISSIONS = 'SECURITY_PERMISSIONS';
const LIST_CHANNEL = 'LIST_CHANNEL';
const LIST_CHANNEL_ERROR = 'LIST_CHANNEL_ERROR';
const ADD_CHANNEL = 'ADD_CHANNEL';
const UPDATE_CHANNEL = 'UPDATE_CHANNEL';
const DELETE_CHANNEL = 'DELETE_CHANNEL';

//reducer
export default function channelReducer(state = data, action) {
    switch (action.type) {
        case SECURITY_PERMISSIONS:
            return { ...state, securityPermission: action.payload };
        case LIST_CHANNEL:
            return { ...state, channels: action.payload };
        case ADD_CHANNEL:
            return { ...state, channelAdd: action.payload };
        case LIST_CHANNEL_ERROR:
            return { ...state, noPermittedChannel: action.payload };
        default:
            return { ...state };
    }
}

export const getPermissions = (username, action) => async (dispatch) => {
    const response = await permission.validPermission(
        env.transaction.channel,
        username,
        env.app.systemCode, action);
    dispatch({
        type: SECURITY_PERMISSIONS,
        payload: response
    });
    return response;
}

export const findChannel = (entity) => async (dispatch) => {
    const response = await service.getChannels(entity).then((r) => { return r.data });
    let data = [];
    if (response != null) {
        if (response.code === undefined) {
            response.forEach((element) => {
                data.push({
                    value: element.id,
                    label: element.type.name.toUpperCase()
                });
            });
        } else {
            dispatch({
                type: LIST_CHANNEL_ERROR,
                payload: response.message
            });
        }
    }
    dispatch({
        type: LIST_CHANNEL,
        payload: data
    });
    return data;
}

export const findRawChannels= (entity) => async (dispatch) => {
    const response = await service.getChannels(entity).then((r) => { return r.data });
    dispatch({
        type: LIST_CHANNEL,
        payload: response
    });
    return response;
}

export const saveChannel = (json) => async (dispatch) => {
    const response = await service.saveChannel(json).then((r) => { return r });
    dispatch({
        type: ADD_CHANNEL,
        payload: response
    });
    return response;
}
export const updateChannel = (json) => async (dispatch) => {
    const response = await service.updateChannel(json).then((r) => { return r });

    dispatch({
        type: UPDATE_CHANNEL,
        payload: response
    });
    return response;
}

export const deleteChannel = (json) => async (dispatch) => {
    const response = await service.deleteChannel(json).then((r) => { return r });

    dispatch({
        type: DELETE_CHANNEL,
        payload: response
    });
    return response;
}